import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { PagamentoContaFinanceiraModel } from "../models/pagamentoContaFinanceira/pagamentoContaFinanceiraModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";

export const cadastrarPagamentoContaFinanceira = createAsyncThunk("/PagamentoContaFinanceira/CadastrarPagamentoContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PagamentoContaFinanceira/CadastrarPagamentoContaFinanceira", payload.value);
    toastSucess("Cadastro do pagamento da conta efetuado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPagamentoContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPagamentoContaFinanceira = createAsyncThunk("/PagamentoContaFinanceira/BuscarPagamentoContaFinanceira", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/PagamentoContaFinanceira/BuscarPagamentoContaFinanceira", { params: { idContaFinanceira: idContaFinanceira } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarPagamentoContaFinanceira = createAsyncThunk("/PagamentoContaFinanceira/AtualizarPagamentoContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PagamentoContaFinanceira/AtualizarPagamentoContaFinanceira", payload.value);
    toastSucess("Pagamento da conta atualizada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPagamentoContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarPagamentoContaFinanceira = createAsyncThunk("/PagamentoContaFinanceira/DeletarPagamentoContaFinanceira", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/PagamentoContaFinanceira/DeletarPagamentoContaFinanceira", { params: { id: payload.value } });
    toastSucess("Pagamento da conta removida com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPagamentoContaFinanceira(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
